// @ts-nocheck
/** MI DOMINO - game/engine. */
import { openDash, renderDash } from '../ui/dashboard';
import { FAN_POOL, GAL_FANS, NAMES, PREMIOS, SEAT_IDS, TEAM_OF, canPlay, fanPhrase, handPips, hasFx } from '../data/config';
import { isPro, pullCollectible, renderTienda, revealCollectible, saveWallet } from '../economy/tienda';
import { renderLobbyQuests } from '../economy/quests';
import { syncFeltSelect, syncSkinSelect, syncWoodSelect } from '../economy/wallet';
import { airhorn, buzzer, celebration, clack, explosion, megaBoom, shuffleSound, siren, turnChime, womp } from './sounds';
import { tileEl } from './tile';
import { addXP, applyProfile, saveStats } from '../identity/profile';
import { netSides, sendPlay } from '../net/online';
import { ACCOUNT, MATCH_LOG, NET, PROFILE, S, SETTINGS, STATS, WALLET, dragIdx, firstHandOfMatch, prevLeftEnd, prevRightEnd, setDragIdx, setDragTile, setFirstHandOfMatch, setMATCH_LOG, setPendingTile, setPrevLeftEnd, setPrevRightEnd, setS } from '../state';
import { banner } from '../ui/banner';
import { addChat, log } from '../ui/feed';
import { LANG, setLang, t } from '../ui/i18n';
import { nudgeTurn } from '../ui/pwa';

/** Inline ES/EN picker for one-off commentary strings (log/banner) that aren't
 *  worth a dictionary key. Reads the live LANG each call. */
export function L(es, en) { return LANG === 'en' ? en : es; }

/* ---- Undo (solo) + "your turn" cue ---- */
let undoSnap = null;       // state to restore = right before your last play
let turnStartSnap = null;  // snapshot taken when your turn begins
let wasMyTurn = false;     // edge-detect the start of your turn (cue + snapshot)

/** Discard undo history — call at every new hand / match. */
export function clearUndo() { undoSnap = null; turnStartSnap = null; wasMyTurn = false; }

/** Soft chime + a brief glow on the rack when it becomes your turn. */
export function turnCue() {
  try { turnChime(); } catch (e) { /* audio may be blocked until first tap */ }
  try { nudgeTurn(); } catch (e) { /* background attention is best-effort */ }
  const hw = document.getElementById('hand-wrap');
  if (hw) { hw.classList.remove('my-turn'); void hw.offsetWidth; hw.classList.add('my-turn'); setTimeout(() => hw.classList.remove('my-turn'), 1500); }
}

/** Take back your last play (solo only) — reverts your ficha and the bot moves
 *  that followed, back to your previous decision. */
export function undoMove() {
  if (NET.active || !undoSnap) return;
  setS(JSON.parse(JSON.stringify(undoSnap)));   // plain data; JSON clone works on every mobile browser
  undoSnap = null;
  setPendingTile(null);
  hideSideChoice();
  clack();
  render();
}

export function applyLang() {
  const set = (id, key, html) => {
    const el = document.getElementById(id);
    if (el) { if (html) el.innerHTML = t(key); else el.textContent = t(key); }
  };
  set('new-match', 'newMatch');
  // app-shell tabs + account menu extras
  // emoji stays, the word is a .tlbl span so phones can collapse tabs to icons
  const tabHTML = (id, emoji, key) => { const el = document.getElementById(id); if (el) el.innerHTML = `${emoji ? emoji + ' ' : ''}<span class="tlbl">${t(key)}</span>`; };
  // Mesa = the oval table with its word across the felt (no emoji)
  const mesaEl = document.getElementById('tab-mesa');
  if (mesaEl) {
    mesaEl.classList.add('tab-table');
    const word = t('tabMesa').toUpperCase();
    mesaEl.innerHTML = `<svg class="table-icon" viewBox="0 0 100 56" width="76" height="44" aria-label="${word}" role="img"><ellipse cx="50" cy="28" rx="48" ry="26" fill="#6b3f1d" stroke="#f0b429" stroke-width="2"/><ellipse cx="50" cy="28" rx="41" ry="21" fill="#1f6b3a" stroke="#0e3a1f" stroke-width="1.5"/><text x="50" y="33" text-anchor="middle" font-family="Montserrat, Segoe UI, sans-serif" font-weight="900" font-size="13" letter-spacing="2" fill="#ffe08a">${word}</text></svg>`;
  }
  tabHTML('btn-dash', '', 'tabDash');
  set('btn-help', 'help');
  set('menu-newmatch', 'newMatch');
  const mlb = document.getElementById('menu-lang');
  if (mlb) mlb.textContent = LANG === 'es' ? '🌐 English' : '🌐 Español';
  set('btn-paso', 'noVoy');
  set('play-left', 'leftEnd');
  set('play-right', 'rightEnd');
  set('lbl-mode', 'mode');
  set('lbl-felt', 'feltLbl');
  set('lbl-fichas', 'fichasLbl');
  set('gal-title', 'galTitle');
  set('gal-foot', 'galFoot');
  set('tp-close', 'back');
  set('dash-close', 'back');
  set('them-label', 'them');
  set('team-label', 'us');
  set('lbl-hints', 'hintsLbl');
  // the human seat's display name follows the language — feeds logs, banners
  // and the count sheet ("YOU · US" instead of "TÚ · US" in English)
  NAMES[0] = t('you');
  const n0 = document.getElementById('name0');
  if (n0 && !PROFILE.name) n0.textContent = t('you');
  const lw = document.getElementById('log-welcome');
  if (lw) lw.textContent = L('¡Bienvenido a la mesa!', 'Welcome to the table!');
  set('lobby-solo', 'soloBtn');
  set('lobby-create', 'createBtn');
  set('lobby-join', 'joinBtn');
  set('lobby-quick', 'quickBtn');
  try { renderLobbyQuests(); } catch (e) { /* quests not initialised yet */ }
  // translate the <option> labels inside the ⚙️ selects (their .value stays)
  const opt = (selId, texts) => {
    const s = document.getElementById(selId);
    if (s) [...s.options].forEach((o, i) => { if (texts[i]) o.textContent = t(texts[i]); });
  };
  opt('hints-select', ['hintOn', 'hintOff']);
  opt('sound-select', ['sndOn', 'sndOff']);
  set('lbl-sound', 'soundLbl');
  // sidebar account menu
  set('acct-profile', 'acctProfile');
  set('acct-password', 'acctPassword');
  set('acct-logout', 'acctLogout');
  set('acct-logout-all', 'acctLogoutAll');
  set('acct-login', 'acctLogin');
  set('acct-install', 'acctInstall');
  const cq = document.getElementById('chat-quick'); if (cq) cq.title = t('quickTitle');
  const al = document.getElementById('acct-label');
  if (al) {
    // signed-in → apodo / full name; guest → "Guest" (no account features exist for them)
    const signedIn = !!(ACCOUNT && ACCOUNT.email);
    al.textContent = '👤 ' + (signedIn ? (PROFILE.name || ACCOUNT.fullname || t('account')) : t('guest'));
    // The whole account menu + Dashboard tab follow the login state LIVE: a
    // signup/login that does not reload the page (signup doesn't) must flip
    // the guest menu (Sign in / How to play) into the real one (profile,
    // password, log out) — it used to be decided once at load.
    document.body.classList.toggle('guest', !signedIn);
    const show = (id, on, disp = 'block') => { const el = document.getElementById(id); if (el) el.style.display = on ? disp : 'none'; };
    show('acct-profile', signedIn); show('acct-password', signedIn); show('acct-logout', signedIn); show('acct-logout-all', signedIn);
    show('acct-login', !signedIn);
    show('btn-dash', signedIn, '');
  }
  opt('mode', ['mode500', 'mode200']);
  opt('felt-select', ['feltGreen', 'feltWine', 'feltOcean', 'feltRoyal']);
  opt('skin', ['skinIvory', 'skinMid', 'skinGold', 'skinCoral']);
  set('lbl-wood', 'woodLbl');
  opt('wood-select', ['woodClassic']);
  set('lbl-scene', 'sceneLbl');
  opt('scene-select', ['sceneClassic', 'scenePlaya', 'sceneMalecon', 'sceneNoche', 'scenePatio', 'sceneCasino', 'sceneCafe']);
  // bought items in the ⚙️ lists carry their own language
  try { syncSkinSelect(); syncFeltSelect(); syncWoodSelect(); } catch (e) { /* before catalog init */ }
  // target-label ("Partida a 500 · CON PREMIOS") — recompute in the active language
  const tl = document.getElementById('target-label');
  if (tl && typeof S !== 'undefined' && S && S.target) {
    tl.textContent = `${t('matchTo')} ${S.target} · ${S.prize ? t('conPremios') : t('casual')}`;
  }
  const bs = document.getElementById('btn-store');
  if (bs) bs.innerHTML = `<span class="tlbl">${t('storeWord')}</span><span class="coins"> · <span id="coin-bal">${typeof WALLET !== 'undefined' ? WALLET.coins : 0}</span> 🪙</span>`;
  const ci = document.getElementById('chat-input');
  if (ci) ci.placeholder = t('chatPh');
  const ln = document.getElementById('lobby-name');
  if (ln) ln.placeholder = t('namePh');
  const lc = document.getElementById('lobby-code');
  if (lc) lc.placeholder = t('codePh');
  const bl = document.getElementById('btn-lang');
  if (bl) bl.textContent = LANG === 'es' ? '🌐 ENGLISH' : '🌐 ESPAÑOL';
  const dl = document.getElementById('dash-lang');
  if (dl) dl.textContent = LANG === 'es' ? '🌐 ENGLISH' : '🌐 ESPAÑOL';
  if (typeof applyProfile === 'function') try { applyProfile(); } catch (e) {}
}

export function premioDeMano() {
  return S && S.prize && S.handNum >= 1 && S.handNum <= 4 ? PREMIOS[S.handNum - 1] : 0;
}

export function newMatch() {
  document.body.classList.add("game-active");
  const target = parseInt(document.getElementById('mode').value, 10);
  setS({
    target,
    prize: target === 500,
    scores: [0, 0],
    handStarter: null,
    over: false,
    history: [],
  });
  setFirstHandOfMatch(true);
  document.getElementById('target-label').textContent =
    `${t('matchTo')} ${target} · ${S.prize ? t('conPremios') : t('casual')}`;
  log(L(`Nueva partida a ${target}. ${S.prize ? '¡Capicú y Chuchazo valen 100!' : 'Sin bonos.'}`,
        `New match to ${target}. ${S.prize ? 'Capicú & Chuchazo pay 100!' : 'No bonuses.'}`), true);
  /* Entrada Triunfal: your name in lights */
  if (typeof hasFx === 'function' && hasFx('fx-entrada')) {
    setTimeout(() => {
      banner(`🌟 ${(PROFILE.name || t('you')).toUpperCase()} ${L('ENTRA A LA MESA', 'JOINS THE TABLE')} 🌟`);
      airhorn();
      fanReact('🌟');
    }, 700);
  }
  newHand();
}

export function newHand() {
  clearUndo();   // fresh hand — no take-backs across hands
  if (S) S._counted = false;   // re-arm the count guard for the new hand
  // build & shuffle 28 tiles
  const pool = [];
  for (let a = 0; a <= 6; a++) for (let b = a; b <= 6; b++) pool.push([a, b]);
  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  S.pool = pool;
  S.hands = [[], [], [], []];
  S.board = [];
  S.leftEnd = null; S.rightEnd = null;
  S.passes = 0;
  document.body.classList.add("game-active");
  S.handOver = false;
  S.phase = 'wash';
  S.washMoves = 0;
  S.handNum = (S.handNum || 0) + 1;
  S.cornetas = 3;

  if (typeof window !== 'undefined' && window._autoDeal) { // automated tests only
    for (let p = 0; p < 4; p++) S.hands[p] = pool.slice(p * 7, p * 7 + 7);
    return startPlayPhase();
  }
  renderWash();
  /* the LOSING team shakes the fichas */
  const washerTeam = S.lastLoserTeam ?? 0;
  if (washerTeam === 0) {
    banner(L('¡A MENEAR FICHA! 🙌', 'SHUFFLE TIME! 🙌'));
    showWashHands(true);
    log(S.lastLoserTeam === 0
      ? L('Perdieron la mano: les toca menear. ¡Mueve el mouse sobre la mesa!',
          'You lost the hand: your team shuffles. Move the mouse over the table!')
      : L('¡A MENEAR FICHA! Mueve el mouse sobre la mesa para revolverlas.',
          'SHUFFLE TIME! Move the mouse over the table to shuffle.'), true);
    readyToDeal();   // STOP button available from the start — stop shuffling & grab whenever
  } else {
    aiWash();
  }
}

export function showWashHands(on) {
  const d = on ? 'block' : 'none';
  document.getElementById('wash-hand-l').style.display = d;
  document.getElementById('wash-hand-r').style.display = d;
}

export function aiWash() {
  S.phase = 'aiwash';
  banner(L('¡A MENEAR FICHA! 🙌', 'SHUFFLE TIME! 🙌'));
  log(L('El equipo que perdió menea las fichas... 🌀', 'The losing team shuffles the dominos... 🌀'), true);
  showWashHands(true);
  const board = document.getElementById('board');
  const W = Math.max((board.clientWidth || 700) - 60, 100);
  const H = Math.max((board.clientHeight || 350) - 40, 80);
  const hl = document.getElementById('wash-hand-l');
  const hr = document.getElementById('wash-hand-r');
  /* AI hands glide smoothly between stirs */
  hl.style.transition = hr.style.transition = 'left .42s ease-in-out, top .42s ease-in-out';
  let n = 0;
  const iv = setInterval(() => {
    /* the hands push the fichas outward as they circle */
    const cx = W / 2, cy = H / 2;
    const px = cx + Math.cos(n * 1.3) * 130;
    const py = cy - 40 + Math.sin(n * 1.3) * 65;
    for (const el of board.querySelectorAll('.wash-tile')) {
      const ex = (parseFloat(el.style.left) || 0) + 23;
      const ey = (parseFloat(el.style.top) || 0) + 12;
      const dx = ex - px, dy = ey - py;
      const dist = Math.hypot(dx, dy);
      if (dist < 190) nudgeTile(el, dx / (dist || 1), dy / (dist || 1), W, H);
    }
    hl.style.left = (px - 115) + 'px';
    hl.style.top = py + 'px';
    hl.style.transform = 'rotate(-7deg)';
    hr.style.left = (px + 16) + 'px';
    hr.style.top = py + 'px';
    hr.style.transform = 'rotate(7deg)';
    shuffleSound();
    n++;
    if (n >= 7) {
      clearInterval(iv);
      showWashHands(false);
      S.phase = 'grab';
      banner(L('¡AGARRA TUS 7! ✋', 'GRAB YOUR 7! ✋'));
      log(L('Ya están meneadas. Toca 7 fichas para agarrarlas.', 'All shuffled. Tap 7 dominos to grab them.'), true);
    }
  }, 450);
}

export function renderWash() {
  render();
  const board = document.getElementById('board');
  board.innerHTML = '';
  const W = Math.max((board.clientWidth || 700) - 60, 100);
  const H = Math.max((board.clientHeight || 350) - 40, 80);
  S.pool.forEach(t => {
    const el = document.createElement('div');
    el.className = 'wash-tile';
    el._tile = t;
    scatterTile(el, W, H);
    el.addEventListener('click', () => {
      if (S.phase !== 'grab' || el._taken) return;
      takeTile(el);
    });
    board.appendChild(el);
  });
}

export function scatterTile(el, W, H) {
  // keep the whole ficha (46×24, rotated) inside the felt so it never scrolls
  el.style.left = Math.floor(14 + Math.random() * Math.max(W - 48, 20)) + 'px';
  el.style.top = Math.floor(10 + Math.random() * Math.max(H - 40, 20)) + 'px';
  const r = Math.floor(Math.random() * 360);
  el.dataset.rot = r;
  el.style.transform = `rotate(${r}deg)`;
}

export function nudgeTile(el, ux, uy, W, H) {
  const push = 30 + Math.random() * 55;
  const nl = Math.min(Math.max(parseFloat(el.style.left) + ux * push + (Math.random() - .5) * 36, 10), W);
  const nt = Math.min(Math.max(parseFloat(el.style.top) + uy * push + (Math.random() - .5) * 36, 10), H);
  el.style.left = nl + 'px';
  el.style.top = nt + 'px';
  const r = (parseFloat(el.dataset.rot) || 0) + (Math.random() - .5) * 110;
  el.dataset.rot = r;
  el.style.transform = `rotate(${r}deg)`;
}

export function readyToDeal() {
  if (S.phase !== 'wash' || document.getElementById('btn-deal')) return;
  const b = document.createElement('button');
  b.id = 'btn-deal';
  b.className = 'btn gold';
  b.textContent = L('⏹ ¡PARAR Y AGARRAR! ✋', '⏹ STOP & GRAB! ✋');
  b.style.cssText = 'position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:20;width:auto;padding:14px 22px;';
  b.onclick = () => {
    b.remove();
    showWashHands(false);
    S.phase = 'grab';
    banner(L('¡AGARRA TUS 7! ✋', 'GRAB YOUR 7! ✋'));
    log(L('Toca 7 fichas para agarrarlas, una por una.', 'Tap 7 dominos to grab them, one by one.'), true);
  };
  document.getElementById('felt').appendChild(b);
}

export function takeTile(el) {
  el._taken = true;
  S.hands[0].push(el._tile);
  clack();
  // fade + shrink in place (don't move below the felt — that made #felt scroll)
  el.style.transition = 'transform .4s ease, opacity .4s ease';
  el.style.transform += ' scale(.2)';
  el.style.opacity = '0';
  setTimeout(() => el.remove(), 420);
  const hand = document.getElementById('hand');
  hand.innerHTML = '';
  for (const t of S.hands[0]) hand.appendChild(tileEl(t, '', true));
  if (S.hands[0].length === 7) {
    S.phase = 'aigrab';
    log(L('¡Listo! Los demás agarran las suyas...', 'Done! The others grab theirs...'), true);
    setTimeout(() => aiGrab(1), 500);
  }
}

export function aiGrab(p) {
  if (p > 3) return startPlayPhase();
  animateHand(p);
  setTimeout(() => {
    const board = document.getElementById('board');
    const free = [...board.querySelectorAll('.wash-tile')].filter(e => !e._taken);
    for (let k = 0; k < 7 && free.length; k++) {
      const i = Math.floor(Math.random() * free.length);
      const el = free.splice(i, 1)[0];
      el._taken = true;
      S.hands[p].push(el._tile);
      el.remove();
    }
    clack();
    render();
    aiGrab(p + 1);
  }, 750);
}

export function startPlayPhase() {
  S.phase = 'play';
  if (firstHandOfMatch) {
    S.turn = S.hands.findIndex(h => h.some(t => t[0] === 6 && t[1] === 6));
    S.mustPlayDouble6 = true;
    log(L(`${NAMES[S.turn]} tiene el doble seis y sale.`, `${NAMES[S.turn]} has the double-six and leads.`));
  } else {
    S.turn = S.handStarter;
    S.mustPlayDouble6 = false;
    log(L(`${NAMES[S.turn]} sale esta mano.`, `${NAMES[S.turn]} leads this hand.`));
  }
  S.handLeader = S.turn; /* quien tiene LA MANO */
  render();
  nextTurn();
}

export function playableSides(tile) {
  if (S.board.length === 0) return S.mustPlayDouble6
    ? (tile[0] === 6 && tile[1] === 6 ? ['first'] : [])
    : ['first'];
  const sides = [];
  if (tile[0] === S.leftEnd || tile[1] === S.leftEnd) sides.push('left');
  if (tile[0] === S.rightEnd || tile[1] === S.rightEnd) sides.push('right');
  return sides;
}

export function advance() {
  S.turn = (S.turn + 1) % 4;
  render();
  nextTurn();
}

export function nextTurn() {
  if (S.handOver || S.over) return;
  render();
  const p = S.turn;
  const playables = S.hands[p].filter(canPlay);

  if (playables.length === 0) {
    if (p === 0) {
      /* nothing automatic: YOU declare it with the ¡NO VOY! button */
      return;
    }
    /* they hit THEIR ¡NO VOY! button too — buzzer and all */
    S.passes++;
    buzzer();
    banner(`${NAMES[p]}: ${L('¡NO VOY!', 'PASS!')} 🙅`);
    log(`${NAMES[p]}: ${L('¡NO VOY!', 'PASS!')} 😬`);
    if (S.passes >= 4) return endHandTranque();
    setTimeout(advance, 900);
    return;
  }
  if (p === 0) return; // wait for human click

  // AI difficulty follows the human's chosen level (offline solo):
  //  · Novato  → friendlier bots: they dump a RANDOM legal ficha (no strategy),
  //             so a beginner wins more and learns the flow.
  //  · Matatán/default → sharp play: prefer doubles, then heaviest ficha.
  setTimeout(() => {
    let tile;
    if (SETTINGS.level === 'rookie') {
      tile = playables[Math.floor(Math.random() * playables.length)];
    } else {
      playables.sort((a, b) => {
        const da = a[0] === a[1] ? 100 : 0, db = b[0] === b[1] ? 100 : 0;
        return (db + b[0] + b[1]) - (da + a[0] + a[1]);
      });
      tile = playables[0];
    }
    const sides = playableSides(tile);
    placeTile(p, tile, sides[Math.floor(Math.random() * sides.length)]);
  }, 850);
}

export function endHandDomino(winner, lastTile) {
  S.handOver = true;
  S.phase = 'count';
  const team = TEAM_OF(winner);
  let bonus = 0;
  const bonusMsg = [];
  if (S.prize) {
    const isChuchazo = lastTile[0] === 0 && lastTile[1] === 0;
    const isCapicu = !isChuchazo && lastTile[0] !== lastTile[1] &&
      prevLeftEnd !== null && prevLeftEnd !== prevRightEnd &&
      lastTile.includes(prevLeftEnd) && lastTile.includes(prevRightEnd);
    // bonusMsg keeps the Spanish term: applyCount tests it with .includes('CHUCHAZO'/'CAPICÚ')
    if (isChuchazo) { bonus = 100; bonusMsg.push('¡CHUCHAZO! +100'); banner(L('¡CHUCHAZO! 💥', 'CHUCHAZO! 💥')); explosion(); }
    else if (isCapicu) { bonus = 100; bonusMsg.push('¡CAPICÚ! +100'); banner(L('¡CAPICÚ! 🎯', 'CAPICÚ! 🎯')); siren(); }
    else banner(L('¡DOMINÓ!', 'DOMINO!'));
  } else banner(L('¡DOMINÓ!', 'DOMINO!'));

  S.handStarter = winner;
  const groups = [];
  for (let i = 0; i < 4; i++) {
    if (i !== winner && S.hands[i].length) {
      groups.push({ name: NAMES[i], team: TEAM_OF(i), tiles: S.hands[i] });
    }
  }
  S.countData = { mode: 'domino', winner, team, bonus, bonusMsg, groups,
    premio: premioDeMano(), handNum: S.handNum,
    title: L(`${NAMES[winner]} dominó la mano`, `${NAMES[winner]} dominated the hand`) };
  log(L(`${NAMES[winner]} se pegó. ¡Voltea las fichas y cuéntalas!`, `${NAMES[winner]} dominated! Flip the dominos and count them!`), true);
  setTimeout(showCountModal, 1300);
}

export function endHandTranque() {
  S.handOver = true;
  S.phase = 'count';
  banner(L('¡TRANQUE! 🔒', 'TRANQUE! 🔒'));
  const groups = [];
  for (let i = 0; i < 4; i++) {
    if (S.hands[i].length) groups.push({ name: NAMES[i], team: TEAM_OF(i), tiles: S.hands[i] });
  }
  S.countData = { mode: 'tranque', groups, premio: premioDeMano(), handNum: S.handNum,
    title: L('¡Tranque! Mesa cerrada', '¡Tranque! Table locked') };
  log(L('¡Tranque! Voltea las fichas de los dos equipos y cuéntalas.', '¡Tranque! Flip both teams\' dominos and count them.'), true);
  setTimeout(showCountModal, 1300);
}

export function showCountModal() {
  const cd = S.countData;
  let idx = 0;
  let html = `<p>${t('countIntro')}</p>`;
  for (const g of cd.groups) {
    html += `<p style="margin-top:8px"><b>${g.name}</b> · ${g.team === 0 ? t('us') : t('them')}</p><div>`;
    for (const t of g.tiles) {
      html += `<span class="count-tile" data-i="${idx++}" data-p="${t[0] + t[1]}" data-team="${g.team}">${t[0]}·${t[1]}</span>`;
    }
    html += '</div>';
  }
  html += L('<p style="margin-top:10px;font-size:17px">Contado: <b id="count-total">0</b> puntos<span id="count-teams" style="opacity:.8"></span></p>',
            '<p style="margin-top:10px;font-size:17px">Counted: <b id="count-total">0</b> points<span id="count-teams" style="opacity:.8"></span></p>');
  if (cd.bonusMsg && cd.bonusMsg.length) {
    html += `<p style="color:var(--gold);font-weight:700">${cd.bonusMsg.join(' · ')} ${L('— se suma al final', '— added at the end')}</p>`;
  }
  if (cd.premio) {
    html += `<p style="color:var(--gold);font-weight:700">${L(`🏆 PREMIO de la mano ${cd.handNum}: +${cd.premio} — se suma al final`, `🏆 HAND PRIZE ${cd.handNum}: +${cd.premio} — added at the end`)}</p>`;
  }
  html += `<button class="btn" id="count-rapid" style="width:100%;margin-top:10px">${t('rapidBtn')}</button>
    <p style="font-size:11px;opacity:.6;margin-top:4px">${t('spaceHint')}</p>`;
  document.getElementById('modal-title').innerHTML = cd.title;
  document.getElementById('modal-body').innerHTML = html;
  const btn = document.getElementById('modal-btn');
  btn.textContent = t('countAll');
  btn.disabled = true;
  btn.style.opacity = .5;
  document.getElementById('modal-bg').classList.add('show');

  const tiles = [...document.querySelectorAll('.count-tile')];
  let total = 0;
  const teamTot = [0, 0];
  let left = tiles.length;
  const done = () => { btn.disabled = false; btn.style.opacity = 1; btn.textContent = t('apply'); };
  for (const el of tiles) {
    el.onclick = () => {
      if (el.classList.contains('counted')) return;
      el.classList.add('counted');
      total += +el.dataset.p;
      teamTot[+el.dataset.team] += +el.dataset.p;
      left--;
      clack();
      document.getElementById('count-total').textContent = total;
      if (cd.mode === 'tranque') {
        document.getElementById('count-teams').textContent = ` · ${t('us')} ${teamTot[0]} — ${t('them')} ${teamTot[1]}`;
      }
      if (left === 0) done();
    };
  }
  if (left === 0) done();

  /* rapid counting: 📱 one button on the phone, 💻 spacebar on the computer */
  const uncounted = () => tiles.find(el => !el.classList.contains('counted'));
  const rapidBtn = document.getElementById('count-rapid');
  if (rapidBtn) {
    rapidBtn.onclick = () => {
      rapidBtn.disabled = true;
      rapidBtn.style.opacity = .5;
      const iv = setInterval(() => {
        const el = uncounted();
        if (el && el.onclick) el.onclick();
        else clearInterval(iv);
      }, 95);
    };
  }
  try {
    if (window._countKey) window.removeEventListener('keydown', window._countKey);
    window._countKey = ev => {
      if (ev.code !== 'Space' && ev.key !== ' ') return;
      ev.preventDefault();
      const el = uncounted();
      if (el && el.onclick) el.onclick();
    };
    window.addEventListener('keydown', window._countKey);
  } catch (e) {}

  btn.onclick = () => {
    if (btn.disabled) return;
    btn.disabled = true;   // guard: a double-tap (common on phones) must not apply twice
    try {
      if (window._countKey) {
        window.removeEventListener('keydown', window._countKey);
        window._countKey = null;
      }
    } catch (e) {}
    document.getElementById('modal-bg').classList.remove('show');
    applyCount(total, teamTot);
  };
}

export function applyCount(total, teamTot) {
  if (S._counted) return;   // re-entry guard: never score the same hand twice
  S._counted = true;
  const cd = S.countData;
  let body = '';
  if (cd.mode === 'domino') {
    const pts = total + cd.bonus + (cd.premio || 0);
    S.scores[cd.team] += pts;
    S.lastLoserTeam = 1 - cd.team;
    const tn = cd.team === 0 ? t('us') : t('them');
    body = L(
      `<p>Contaste <b>${total}</b> puntos${cd.bonus ? ` + <b>${cd.bonus}</b> de bono` : ''}${cd.premio ? ` + <b>${cd.premio}</b> de PREMIO (mano ${cd.handNum})` : ''}.</p>
            <p><b>${tn}</b> +${pts}</p>`,
      `<p>You counted <b>${total}</b> points${cd.bonus ? ` + <b>${cd.bonus}</b> bonus` : ''}${cd.premio ? ` + <b>${cd.premio}</b> PRIZE (hand ${cd.handNum})` : ''}.</p>
            <p><b>${tn}</b> +${pts}</p>`);
    log(`${tn} +${pts} ${cd.bonusMsg.join(' ')}`, true);
    const tags = [];
    if (cd.bonusMsg.some(m => m.includes('CHUCHAZO'))) tags.push('💥');
    if (cd.bonusMsg.some(m => m.includes('CAPICÚ'))) tags.push('🎯');
    if (cd.premio) tags.push('🏆');
    (S.history = S.history || []).push({ n: cd.handNum, team: cd.team, pts, tags });
    STATS.hands++;
    if (cd.team === 0) {
      STATS.handsWon++;
      if (cd.bonusMsg.some(m => m.includes('CAPICÚ'))) { STATS.capicus++; addXP(25, 'capicú 🎯'); }
      if (cd.bonusMsg.some(m => m.includes('CHUCHAZO'))) { STATS.chuchazos++; addXP(40, 'chuchazo 💥'); }
      addXP(10, L('mano ganada', 'hand won'));
      earnCoins(25, L('mano ganada', 'hand won'));
    }
    saveStats();
    finishHand(cd.title, body);
  } else {
    if (teamTot[0] === teamTot[1]) {
      /* EMPATE: ¡LA MANO GANA! El equipo que salió se lleva todo */
      const leader = S.handLeader ?? 0;
      const team = TEAM_OF(leader);
      const pts = teamTot[0] + teamTot[1] + (S.prize ? 25 : 0) + (cd.premio || 0);
      S.scores[team] += pts;
      S.lastLoserTeam = 1 - team;
      S.handStarter = leader;
      const tn = team === 0 ? t('us') : t('them');
      banner(L('¡LA MANO GANA! ✋', 'THE HAND WINS! ✋'));
      body = L(
        `<p>Empate a <b>${teamTot[0]}</b> puntos por equipo...</p>
              <p><b>¡LA MANO GANA!</b> ${NAMES[leader]} salió esta mano.</p>
              <p><b>${tn}</b> se lleva todo${S.prize ? ' <b>+ 25 del tranque</b>' : ''}${cd.premio ? ` <b>+ ${cd.premio} de PREMIO</b>` : ''}: <b>+${pts}</b></p>`,
        `<p>Tie at <b>${teamTot[0]}</b> points per team...</p>
              <p><b>THE HAND WINS!</b> ${NAMES[leader]} led this hand.</p>
              <p><b>${tn}</b> takes it all${S.prize ? ' <b>+ 25 for the tranque</b>' : ''}${cd.premio ? ` <b>+ ${cd.premio} PRIZE</b>` : ''}: <b>+${pts}</b></p>`);
      log(L(`Tranque empatado: ¡LA MANO GANA! ${tn} +${pts} (salió ${NAMES[leader]})`,
            `Tied tranque: THE HAND WINS! ${tn} +${pts} (${NAMES[leader]} led)`), true);
      (S.history = S.history || []).push({ n: cd.handNum, team, pts, tags: cd.premio ? ['🔒', '✋', '🏆'] : ['🔒', '✋'] });
      STATS.hands++;
      if (team === 0) {
        STATS.handsWon++;
        STATS.tranquesWon++;
        addXP(30, L('tranque ganado con la mano ✋', 'tranque won with la mano ✋'));
        earnCoins(25, L('tranque ganado con la mano', 'tranque won with la mano'));
      }
      saveStats();
    } else {
      const team = teamTot[0] < teamTot[1] ? 0 : 1;
      const pts = teamTot[0] + teamTot[1] + (S.prize ? 25 : 0) + (cd.premio || 0);
      S.scores[team] += pts;
      S.lastLoserTeam = 1 - team;
      const members = team === 0 ? [0, 2] : [1, 3];
      S.handStarter = handPips(S.hands[members[0]]) <= handPips(S.hands[members[1]]) ? members[0] : members[1];
      const tn = team === 0 ? t('us') : t('them');
      body = L(
        `<p><b>${tn}</b> tiene menos (${Math.min(...teamTot)} vs ${Math.max(...teamTot)}).</p>
              <p>Se lleva los sobrantes${S.prize ? ' <b>+ 25 del tranque</b>' : ''}${cd.premio ? ` <b>+ ${cd.premio} de PREMIO</b>` : ''}: <b>+${pts}</b></p>`,
        `<p><b>${tn}</b> has fewer (${Math.min(...teamTot)} vs ${Math.max(...teamTot)}).</p>
              <p>Takes the leftovers${S.prize ? ' <b>+ 25 for the tranque</b>' : ''}${cd.premio ? ` <b>+ ${cd.premio} PRIZE</b>` : ''}: <b>+${pts}</b></p>`);
      log(`Tranque: ${tn} +${pts}`, true);
      (S.history = S.history || []).push({ n: cd.handNum, team, pts, tags: cd.premio ? ['🔒', '🏆'] : ['🔒'] });
      STATS.hands++;
      if (team === 0) {
        STATS.handsWon++;
        STATS.tranquesWon++;
        addXP(25, L('tranque ganado 🔒', 'tranque won 🔒'));
        earnCoins(25, L('tranque ganado', 'tranque won'));
      }
      saveStats();
    }
    finishHand(L('¡Tranque!', 'Tranque!'), body);
  }
}

export function finishHand(title, bodyHTML) {
  setFirstHandOfMatch(false);
  render();
  setTimeout(() => {
    if (S.scores[0] >= S.target || S.scores[1] >= S.target) {
      S.over = true;
      const w = S.scores[0] >= S.target ? 'NOSOTROS' : 'ELLOS';
      const emoji = w === 'NOSOTROS' ? '🏆🔥' : '😤';
      STATS.matches++;
      if (w === 'NOSOTROS') {
        STATS.matchesWon++;
        STATS.streak++;
        STATS.bestStreak = Math.max(STATS.bestStreak, STATS.streak);
        /* competitive scoring: base + margin bonus × streak multiplier */
        const margin = Math.max(S.scores[0] - S.scores[1], 0);
        const base = 50 + Math.min(30, Math.round(margin / 10));
        const mult = STATS.streak >= 4 ? 1.5 : STATS.streak >= 2 ? 1.25 : 1;
        addXP(Math.round(base * mult),
          STATS.streak >= 2 ? L(`¡VICTORIA! (racha 🔥x${STATS.streak})`, `VICTORY! (streak 🔥x${STATS.streak})`) : L('¡VICTORIA!', 'VICTORY!'));
        celebration(); fireworks(); earnCoins(150, L('¡PARTIDA GANADA! 🏆', 'MATCH WON! 🏆'));
        /* victory drop: chance of a collectible, better with streaks */
        const dropChance = 0.2 + Math.min(0.3, STATS.streak * 0.05);
        if (isPro() && Math.random() < dropChance) {
          setTimeout(() => {
            revealCollectible(pullCollectible(STATS.streak >= 4 ? 2 : 0),
              LANG === 'en' ? '🏆 Victory drop' : '🏆 Ficha de victoria');
          }, 2600);
        }
      } else {
        STATS.streak = 0;
        womp();
      }
      saveStats();
      MATCH_LOG.unshift({ d: Date.now(), won: w === 'NOSOTROS', a: S.scores[0], b: S.scores[1] });
      setMATCH_LOG(MATCH_LOG.slice(0, 20));
      saveMatchLog();
      showModal(`${emoji} ¡${w === 'NOSOTROS' ? t('us') : t('them')} ${LANG === 'en' ? 'WIN THE MATCH!' : 'GANAN LA PARTIDA!'}`,
        bodyHTML + `<p style="font-size:18px;margin-top:10px"><b>${S.scores[0]} — ${S.scores[1]}</b></p>`,
        t('newMatch'), newMatch);
    } else {
      showModal(title, bodyHTML +
        `<p style="margin-top:10px">${t('score')}: <b>${t('us')} ${S.scores[0]} — ${S.scores[1]} ${t('them')}</b> (${t('matchTo').toLowerCase()} ${S.target})</p>`,
        t('nextHand'), newHand);
    }
  }, 1400);
}

export function onTileClick(tile) {
  if (NET.active) return netTileClick(tile);
  if (S.turn !== 0 || S.handOver || S.over || S.phase !== 'play' || S.busy) return;
  if (S.board.length === 0) return attemptPlace(tile, 'first');
  /* YOU choose the end — every time */
  setPendingTile(tile);
  document.getElementById('side-choice').classList.add('show');
}

export function attemptPlace(tile, side) {
  if (S.busy) return;
  const valid = playableSides(tile);
  let legal = valid.includes(side) || (side === 'first' && valid.includes('first'));
  /* if the ficha fits the OTHER end, it plays there — a good ficha is never rejected
     just because the drop landed near the wrong end */
  if (!legal && valid.length && valid[0] !== 'first') {
    side = valid.includes('left') ? 'left' : 'right';
    legal = true;
  }
  setPrevLeftEnd(S.leftEnd); setPrevRightEnd(S.rightEnd);
  if (legal) {
    undoSnap = turnStartSnap;   // enable "undo" back to before this play (solo)
    if (hasFx('fx-slam')) { shakeArena(); megaBoom(); }
    return placeTile(0, tile, side);
  }

  /* ILLEGAL PLAY: it goes on the table anyway... until someone yells */
  S.busy = true;
  const saved = { leftEnd: S.leftEnd, rightEnd: S.rightEnd };
  const h = S.hands[0];
  h.splice(h.findIndex(t => t[0] === tile[0] && t[1] === tile[1]), 1);
  if (S.board.length === 0) { S.board.push([tile[0], tile[1]]); S.lastIdx = 0; }
  else if (side === 'left') { S.board.unshift([tile[0], tile[1]]); S.lastIdx = 0; }
  else { S.board.push([tile[0], tile[1]]); S.lastIdx = S.board.length - 1; }
  S.justPlayed = true;
  clack();
  render();
  setTimeout(() => {
    const catcher = NAMES[Math.random() < 0.5 ? 1 : 3];
    banner(L('¡ESA NO VA! 😤', 'THAT ONE DOESN\'T GO! 😤'));
    log(L(`${catcher} te la cantó: esa ficha no pega ahí. ¡Devuélvela y juega bien!`,
          `${catcher} called you out: that domino doesn't fit there. Take it back and play right!`), true);
    if (S.board.length) {
      if (side === 'left') S.board.shift(); else S.board.pop();
    }
    S.leftEnd = saved.leftEnd;
    S.rightEnd = saved.rightEnd;
    S.hands[0].push(tile);
    S.busy = false;
    render();
  }, 1300);
}

export function hideSideChoice() { document.getElementById('side-choice').classList.remove('show'); }

/* the two drop spots on the felt (left / right end of the snake) */
export const zoneL = document.getElementById('drop-left');
export const zoneR = document.getElementById('drop-right');

export function showZones(tile) {
  if (!SETTINGS.hints) return;   // drop-spot hints are off (matatán mode)
  const sides = sidesFor(tile);
  const first = sides.includes('first');
  zoneL.textContent = first ? '⬇' : '◀';
  zoneL.classList.toggle('show', first || sides.includes('left'));
  zoneR.classList.toggle('show', sides.includes('right'));
}

export function hideZones() {
  zoneL.classList.remove('show', 'over');
  zoneR.classList.remove('show', 'over');
}

export function animateHand(player, rect) {
  try {
    const seat = document.getElementById(SEAT_IDS[player]);
    const r = seat.getBoundingClientRect();
    const tgt = rect || document.getElementById('board-wrap').getBoundingClientRect();
    const h = document.getElementById('play-hand');
    h.style.display = 'block';
    h.style.left = (r.left + r.width / 2 - 22) + 'px';
    h.style.top = (r.top + r.height / 2 - 22) + 'px';
    h.getBoundingClientRect(); // force reflow so the transition runs
    /* travel to the exact spot where the tile lands */
    h.style.left = (tgt.left + tgt.width / 2 - 22) + 'px';
    h.style.top = (tgt.top + tgt.height / 2 - 22) + 'px';
    setTimeout(() => { h.style.display = 'none'; }, 650);
  } catch (e) {}
}

export function boardEndRect(side) {
  try {
    const kids = document.getElementById('board').children;
    if (!kids.length) return null;
    const el = side === 'left' ? kids[0] : kids[kids.length - 1];
    return el.getBoundingClientRect();
  } catch (e) { return null; }
}

export function fireworks() {
  /* full-screen fireworks show for the winners */
  try {
    const cv = document.getElementById('fx');
    if (!cv) return;
    cv.style.display = 'block';
    cv.width = window.innerWidth;
    cv.height = window.innerHeight;
    const g = cv.getContext('2d');
    const parts = [];
    /* PhilCoin gold — pure gold fireworks */
    const colors = ['#f0b429', '#ffd76e', '#ffea9e', '#e6a41d', '#fff3c4', '#c9920f'];
    let bursts = 0;
    const burst = () => {
      const x = cv.width * (0.15 + Math.random() * 0.7);
      const y = cv.height * (0.12 + Math.random() * 0.45);
      const col = colors[Math.floor(Math.random() * colors.length)];
      for (let i = 0; i < 70; i++) {
        const a = (Math.PI * 2 * i) / 70 + Math.random() * 0.12;
        const sp = 2 + Math.random() * 4.5;
        parts.push({ x, y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, life: 1, col });
      }
      /* Lluvia de Bandera: your flag rains with the gold */
      if (typeof hasFx === 'function' && hasFx('fx-bandera')) {
        for (let i = 0; i < 10; i++) {
          const a = Math.random() * Math.PI * 2;
          const sp = 1.5 + Math.random() * 3;
          parts.push({
            x, y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 1, life: 1,
            glyph: (typeof PROFILE !== 'undefined' && PROFILE.country) || '🇩🇴',
            size: 16 + Math.random() * 10,
          });
        }
      }
      /* PhilCoins burst out too — spinning gold coins */
      for (let i = 0; i < 14; i++) {
        const a = Math.random() * Math.PI * 2;
        const sp = 1.5 + Math.random() * 3.5;
        parts.push({
          x, y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 1, life: 1,
          coin: true, r: 7 + Math.random() * 6,
          spin: Math.random() * Math.PI, spinV: 0.12 + Math.random() * 0.2,
        });
      }
      bursts++;
      if (bursts < 12) setTimeout(burst, 260 + Math.random() * 400);
    };
    burst();
    const t0 = Date.now();
    (function frame() {
      g.clearRect(0, 0, cv.width, cv.height);
      for (const p of parts) {
        if (p.life <= 0) continue;
        p.x += p.vx; p.y += p.vy;
        p.vy += p.coin ? 0.085 : 0.05;
        p.vx *= 0.985; p.vy *= 0.99;
        p.life -= p.coin ? 0.008 : 0.011;
        g.globalAlpha = Math.max(p.life, 0);
        if (p.glyph) {
          g.font = `${p.size}px serif`;
          g.textAlign = 'center';
          g.fillText(p.glyph, p.x, p.y);
        } else if (p.coin) {
          p.spin += p.spinV;
          const w = Math.abs(Math.cos(p.spin)); /* 3D flip */
          g.save();
          g.translate(p.x, p.y);
          g.scale(Math.max(w, 0.08), 1);
          const gr = g.createRadialGradient(-p.r * 0.3, -p.r * 0.3, 1, 0, 0, p.r);
          gr.addColorStop(0, '#fff3c4');
          gr.addColorStop(0.55, '#f0b429');
          gr.addColorStop(1, '#b8860b');
          g.fillStyle = gr;
          g.beginPath(); g.arc(0, 0, p.r, 0, Math.PI * 2); g.fill();
          g.strokeStyle = '#8a6508'; g.lineWidth = 1.5; g.stroke();
          g.fillStyle = '#8a6508';
          g.font = `bold ${Math.floor(p.r * 1.15)}px Georgia`;
          g.textAlign = 'center'; g.textBaseline = 'middle';
          g.fillText('P', 0, 1);
          g.restore();
        } else {
          g.fillStyle = p.col;
          g.fillRect(p.x, p.y, 3.2, 3.2);
        }
      }
      g.globalAlpha = 1;
      if (Date.now() - t0 < 6500) requestAnimationFrame(frame);
      else cv.style.display = 'none';
    })();
  } catch (e) {}
}

export function layoutBoard(container, tiles, hotIdx) {
  container.innerHTML = '';
  if (!tiles.length) return;
  const W = container.clientWidth || 800;
  const H = container.clientHeight || 400;
  const L = 58, SH = 30, GAP = 4, ROW = 76;
  const rowCy = r => r * ROW + ROW / 2;

  /* pass 1: walk the path.
     Reserve room for the corner tile so the turn happens BEFORE the edge
     and the elbow never overlaps its neighbors. */
  let x = 0, dir = 1, row = 0;
  const pos = [];
  const RESERVE = SH + GAP; // space kept free for the corner column
  for (let i = 0; i < tiles.length; i++) {
    const dbl = tiles[i][0] === tiles[i][1];
    const w = dbl ? SH : L, h = dbl ? L : SH;
    const fits = dir > 0 ? x + w <= W - RESERVE : x - w >= RESERVE;
    if (!fits) {
      /* corner tile: vertical, bridging this row down to the next */
      const cw = SH, ch = L;
      const left = dir > 0 ? Math.min(x, W - cw) : Math.max(x - cw, 0);
      const top = (rowCy(row) + rowCy(row + 1)) / 2 - ch / 2;
      pos.push({ left, top, w: cw, h: ch, dir, dbl, corner: true });
      row++;
      dir = -dir;
      x = dir > 0 ? left + cw + GAP : left - GAP;
      continue;
    }
    const left = dir > 0 ? x : x - w;
    pos.push({ left, top: rowCy(row) - h / 2, w, h, dir, dbl, corner: false });
    x += dir * (w + GAP);
  }

  /* pass 2: center the whole snake on the felt */
  let minL = 1e9, maxR = -1e9, minT = 1e9, maxB = -1e9;
  for (const p of pos) {
    minL = Math.min(minL, p.left); maxR = Math.max(maxR, p.left + p.w);
    minT = Math.min(minT, p.top);  maxB = Math.max(maxB, p.top + p.h);
  }
  const offX = (W - (maxR - minL)) / 2 - minL;
  const offY = (H - (maxB - minT)) / 2 - minT;

  /* pass 3: place tiles (flip halves on leftward runs so the chain reads right) */
  for (let i = 0; i < tiles.length; i++) {
    const t = tiles[i], p = pos[i];
    let disp = t;
    if (!p.corner && !p.dbl && p.dir < 0) disp = [t[1], t[0]];
    const el = tileEl(disp, '', p.dbl || p.corner);
    el.style.left = (p.left + offX) + 'px';
    el.style.top = (p.top + offY) + 'px';
    if (i === hotIdx) el.classList.add('just-played');
    container.appendChild(el);
  }

  /* pass 4: if the snake is bigger than the board (small phone felt), scale the
     whole chain down to fit — keeps it centered and stops tiles spilling onto
     the rails / off the felt. scale=1 on a roomy desktop board (no change). */
  const snakeW = maxR - minL, snakeH = maxB - minT;
  const scale = Math.min(1, (W - 6) / snakeW, (H - 6) / snakeH);
  container.style.transformOrigin = 'center center';
  container.style.transform = scale < 0.999 ? `scale(${scale.toFixed(3)})` : '';
}

export function render() {
  if (!S) return;
  document.getElementById('score0').textContent = S.scores[0];
  document.getElementById('score1').textContent = S.scores[1];

  // PREMIOS label (top left): first 4 hands pay 100·75·50·25
  const pl = document.getElementById('premio-label');
  if (pl) {
    const p = premioDeMano();
    pl.textContent = (!NET.active && S.prize)
      ? `${t('premiosLbl')}: 100·75·50·25${p ? ` · ${t('mano')} ${S.handNum}: +${p}` : ` · ${t('sinPremio')}`}`
      : '';
  }

  // the anotación: one row per hand played
  const srBox = document.getElementById('score-rows');
  if (srBox) {
    if (!NET.active && S.history && S.history.length) {
      let rows = L('<div class="sr head"><span>Mano</span><span>Nos</span><span>Ellos</span></div>',
                   '<div class="sr head"><span>Hand</span><span>Us</span><span>Them</span></div>');
      for (const r of S.history) {
        rows += `<div class="sr"><span>${r.n} ${r.tags.join('')}</span>` +
          `<span class="${r.team === 0 ? 'win' : ''}">${r.team === 0 ? '+' + r.pts : '—'}</span>` +
          `<span class="${r.team === 1 ? 'win' : ''}">${r.team === 1 ? '+' + r.pts : '—'}</span></div>`;
      }
      srBox.innerHTML = rows;
      srBox.scrollTop = srBox.scrollHeight;
    } else {
      srBox.innerHTML = '';
    }
  }

  // La Corneta shows only when owned & equipped
  const cor = document.getElementById('btn-corneta');
  if (cor) cor.style.display = (typeof hasFx === 'function' && hasFx('fx-corneta')) ? 'block' : 'none';

  // ¡NO VOY! only appears when it's your turn AND you truly have no move —
  // you can never legally pass with a playable ficha, so hiding it then avoids
  // the confusing "¡NO SEAS TRAMPOSO!" rejection.
  const pb = document.getElementById('btn-paso');
  if (pb) {
    const myTurnPlay = !NET.active && S.phase === 'play' && S.turn === 0 && !S.handOver && !S.over && !S.busy;
    pb.style.display = (myTurnPlay && !S.hands[0].some(canPlay)) ? 'inline-block' : 'none';
  }

  // "your turn" cue + undo snapshot — edge-detected at the start of your turn
  const myTurnCue = !NET.active && S.phase === 'play' && S.turn === 0 && !S.handOver && !S.over;
  if (myTurnCue && !wasMyTurn) {
    turnStartSnap = JSON.parse(JSON.stringify(S));   // remember the pre-decision state (no structuredClone: iOS < 15.4)
    turnCue();
  }
  wasMyTurn = myTurnCue;
  const ub = document.getElementById('btn-undo');
  if (ub) {
    ub.textContent = t('undo');
    ub.style.display = 'none';   // undo is not part of the game (illegal move) — button disabled
  }

  // board (snake layout) — leave the board alone during wash/grab rituals
  if (!S.phase || S.phase === 'play' || S.phase === 'count') {
    layoutBoard(document.getElementById('board'), S.board, S.justPlayed ? S.lastIdx : -1);
  }
  S.justPlayed = false;

  // hand
  const hand = document.getElementById('hand');
  hand.innerHTML = '';
  const myTurnNow = S.phase === 'play' && S.turn === 0 && !S.handOver && !S.over;
  S.hands[0].forEach((t, idx) => {
    /* Rookie hints (⚙️ → Ayudas ON): glow the fichas you CAN play, dim the rest.
       Matatán (hints OFF): no highlights — you know where your ficha goes. */
    const hint = (SETTINGS.hints && myTurnNow) ? (playableSides(t).length ? 'playable' : 'dead') : '';
    const el = tileEl(t, hint, true);
    el.onclick = () => onTileClick(t);
    if (S.phase === 'play' && !S.handOver && !S.over) {
      /* always draggable: drop on the felt to play (your turn),
         or drop on another ficha to SORT your hand however you want */
      el.draggable = true;
      el.addEventListener('dragstart', ev => {
        setDragTile(t);
        setDragIdx(idx);
        ev.dataTransfer.setData('text/plain', 'tile');
        showZones(t);   // show the valid drop spots (left/right end) while dragging
      });
      el.addEventListener('dragend', hideZones);
      el.addEventListener('dragover', ev => {
        ev.preventDefault();
        el.classList.add('sort-over');
      });
      el.addEventListener('dragleave', () => el.classList.remove('sort-over'));
      el.addEventListener('drop', ev => {
        ev.preventDefault();
        ev.stopPropagation();
        el.classList.remove('sort-over');
        if (dragIdx === null || dragIdx === idx) { setDragTile(null); setDragIdx(null); return; }
        const h = S.hands[0];
        const [moved] = h.splice(dragIdx, 1);
        h.splice(idx, 0, moved);
        setDragTile(null); setDragIdx(null);
        clack();
        render();
      });
    }
    hand.appendChild(el);
  });

  // opponents' tile backs + active glow
  for (const p of [1, 2, 3]) {
    const backs = document.getElementById('backs' + p);
    backs.innerHTML = '';
    for (let i = 0; i < S.hands[p].length; i++) {
      const b = document.createElement('div'); b.className = 'back'; backs.appendChild(b);
    }
  }
  document.getElementById('seat-right').classList.toggle('active', S.turn === 1);
  document.getElementById('seat-top').classList.toggle('active', S.turn === 2);
  document.getElementById('seat-left').classList.toggle('active', S.turn === 3);
  document.getElementById('me-info').classList.toggle('active', S.turn === 0);
}

export function showModal(title, body, btnLabel, onNext, dismissable) {
  document.getElementById('modal-title').innerHTML = title;
  document.getElementById('modal-body').innerHTML = body;
  const btn = document.getElementById('modal-btn');
  btn.disabled = false;
  btn.style.opacity = 1;
  btn.textContent = btnLabel;
  btn.onclick = () => { document.getElementById('modal-bg').classList.remove('show'); onNext(); };
  // Optional ✕ to dismiss without taking the action (e.g. the PRO upsell).
  const x = document.getElementById('modal-x');
  if (x) {
    x.style.display = dismissable ? 'block' : 'none';
    x.onclick = () => document.getElementById('modal-bg').classList.remove('show');
  }
  document.getElementById('modal-bg').classList.add('show');
}

export function sidesFor(tile) { return NET.active ? netSides(tile) : playableSides(tile); }

export function netTileClick(tile) {
  const s = NET.snap;
  if (!s || s.turn !== s.mySeat) return;
  const ss = netSides(tile);
  if (!ss.length) return;
  if (ss.length === 1 || ss[0] === 'first') sendPlay(tile, ss[0]);
  else { setPendingTile(tile); document.getElementById('side-choice').classList.add('show'); }
}

export function lobbyName() { return document.getElementById('lobby-name').value.trim() || L('Jugador', 'Player'); }

export function earnCoins(n, why) {
  WALLET.coins += n;
  saveWallet();
  log(`+${n} 🪙 PhilCoins — ${why}`, true);
}

export function shakeArena() {
  try {
    const a = document.getElementById('arena');
    a.classList.remove('shake');
    void a.offsetWidth;
    a.classList.add('shake');
    setTimeout(() => a.classList.remove('shake'), 420);
  } catch (e) {}
}

export function fiestaLights() {
  try {
    const a = document.getElementById('arena');
    a.classList.add('fiesta');
    setTimeout(() => a.classList.remove('fiesta'), 2700);
  } catch (e) {}
}

export function saveMatchLog() { try { localStorage.setItem('matchlog', JSON.stringify(MATCH_LOG.slice(0, 20))); } catch (e) {} }

export function renderGaleria() {
  const g = document.getElementById('gal-grid');
  if (!g) return;
  let html = '';
  for (let i = 0; i < 9; i++) {
    const f = GAL_FANS[i];
    html += f
      ? `<div class="gal-slot filled" data-fan="${i}">${f[0]}<small>${f[1]}</small></div>`
      : `<div class="gal-slot" data-fan="${i}"><span class="plus">+</span></div>`;
  }
  g.innerHTML = html;
  for (const el of g.querySelectorAll('.gal-slot')) {
    el.onclick = () => {
      const i = +el.dataset.fan;
      if (!GAL_FANS[i]) {
        const taken = GAL_FANS.filter(Boolean).map(f => f[1]);
        const pool = FAN_POOL.filter(f => !taken.includes(f[1]));
        if (!pool.length) return;
        GAL_FANS[i] = pool[Math.floor(Math.random() * pool.length)];
        addChat(GAL_FANS[i][1], L('¡Llegué a la galería! 🎉', 'Made it to the gallery! 🎉'));
        fanReact('👋');
      } else {
        fanReact('❤️');
      }
      renderGaleria();
    };
  }
}

export function fanReact(emoji) {
  try {
    if (!GAL_FANS.some(Boolean)) return;
    const gal = document.getElementById('galeria').getBoundingClientRect();
    const n = 1 + Math.floor(Math.random() * 3);
    for (let k = 0; k < n; k++) {
      const el = document.createElement('div');
      el.className = 'gal-react';
      el.textContent = emoji;
      el.style.left = (gal.left + 16 + Math.random() * Math.max(gal.width - 40, 40)) + 'px';
      el.style.top = (gal.bottom - 12) + 'px';
      el.style.animationDelay = (Math.random() * 0.45) + 's';
      document.body.appendChild(el);
      setTimeout(() => el.remove(), 3400);
    }
    if (Math.random() < 0.35) {
      const fans = GAL_FANS.filter(Boolean);
      const f = fans[Math.floor(Math.random() * fans.length)];
      setTimeout(() => addChat(f[1], fanPhrase()), 500);
    }
  } catch (e) {}
}

export function toggleLang() {
  setLang(LANG === 'es' ? 'en' : 'es');
  applyLang();
  try {
    if (S) render();
    if (document.getElementById('tienda-page').classList.contains('show')) renderTienda();
    if (document.getElementById('dash-page').classList.contains('show')) renderDash();
  } catch (e) {}
  // (btn-store keeps its openTienda handler from main.ts — applyLang only
  //  rewrites its innerHTML; re-binding it to the dashboard here was a bug)
}

/* physical presence: the AI reaches out with a hand, then places; your own
   ficha lands at once */
export function placeTile(player, tile, side) {
  if (player !== 0) {
    setPrevLeftEnd(S.leftEnd); setPrevRightEnd(S.rightEnd);
    animateHand(player, boardEndRect(side)); // reach to where it will be placed
    setTimeout(() => placeTileNow(player, tile, side), 480);
  } else {
    placeTileNow(player, tile, side);
  }
}

function placeTileNow(player, tile, side) {
  const h = S.hands[player];
  h.splice(h.findIndex(t => t[0] === tile[0] && t[1] === tile[1]), 1);

  if (S.board.length === 0) {
    S.board.push([tile[0], tile[1]]);
    S.leftEnd = tile[0]; S.rightEnd = tile[1];
    S.mustPlayDouble6 = false;
    S.lastIdx = 0;
  } else if (side === 'left') {
    const oriented = tile[1] === S.leftEnd ? [tile[0], tile[1]] : [tile[1], tile[0]];
    S.board.unshift(oriented);
    S.leftEnd = oriented[0];
    S.lastIdx = 0;
  } else {
    const oriented = tile[0] === S.rightEnd ? [tile[0], tile[1]] : [tile[1], tile[0]];
    S.board.push(oriented);
    S.rightEnd = oriented[1];
    S.lastIdx = S.board.length - 1;
  }
  S.passes = 0;
  S.justPlayed = true;
  clack();

  if (S.hands[player].length === 0) return endHandDomino(player, tile);
  advance();
}
